import { render, staticRenderFns } from "./LatestRace.vue?vue&type=template&id=724aa882&"
import script from "./LatestRace.vue?vue&type=script&lang=js&"
export * from "./LatestRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports